<form [formGroup]="signupForm" (ngSubmit)="onSubmit(signupForm, accountType)"
      class="w-100 flex-grow-1 d-flex flex-column signup-form">
  <div class="w-100">
    <h4 class="mb-2 f-size-20-md-sm" [class.text-center]="isModal">{{ title | translate }}</h4>

    <div class="types mb-3 mt-2 d-inline-flex p-1">
      <button *ngFor="let role of roles" mat-button (click)="changeStep.emit(role?.id!)"
              type="button" [ngClass]="accountType == role?.id ? 'active' : ''">
        {{ 'IM_A' | translate }} {{ (role?.name)! + '_SM' | uppercase | translate }}
      </button>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="firstName">{{ 'WHATS_FIRST_NAME' | translate }}</label>
          <input type="text" class="auth-input w-100 input-bordered" id="firstName" placeholder="{{ 'FIRST_NAME' | translate }}"
                 formControlName="firstName" meTutorsLettersOnly meTutorsTrimInput>
          <div class="text-error" *ngIf="firstName?.touched && firstName?.invalid">
            {{ 'WRITE_VALID_FIRST_NAME' | translate }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="lastName">{{ 'WHATS_LAST_NAME' | translate }}</label>
          <input type="text" class="auth-input w-100 input-bordered" id="lastName" placeholder="{{ 'LAST_NAME' | translate }}"
                 formControlName="lastName" meTutorsLettersOnly meTutorsTrimInput>
          <div class="text-error" *ngIf="lastName?.touched && lastName?.invalid">
            {{ 'WRITE_VALID_LAST_NAME' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label for="email">
        {{ 'EMAIL' | translate }} 
        <span class="ms-1" *ngIf="accountType === userRole.tutor">({{ 'USE_GMAIL_ACCOUNT_ONLY' | translate }})</span>
      </label>
      <input type="email" class="auth-input w-100 input-bordered" id="email" placeholder="{{ 'ENTER_UR_EMAIL' | translate }}"
             formControlName="email" email>
      <span class="text-error" *ngIf="email?.invalid && email?.touched">
        {{ 'WRITE_VALID_EMAIL' | translate }}
      </span>
    </div>

    <div class="form-group">
      <label for="phone">{{ 'PHONE_NUMBER' | translate }}</label>
      <div class="w-100">
        <ngx-intl-tel-input [cssClass]="'auth-input w-100 input-bordered'"
                            [ngClass]="{'has-error': phoneNumber?.invalid && phoneNumber?.touched}"
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [searchCountryFlag]="true"
                            [selectFirstCountry]="true"
                            [phoneValidation]="true"
                            [separateDialCode]="true"
                            [customPlaceholder]="'ENTER_YOUR_PHONE_NUMBER' | translate"
                            [maxLength]="15"
                            [onlyCountries]="onlyCountries"
                            [numberFormat]="PhoneNumberFormat.National"
                            formControlName="mobileNumber">
        </ngx-intl-tel-input>
        <span class="text-error" *ngIf="phoneNumber?.invalid && phoneNumber?.touched">
          {{ 'WRITE_VALID_PHONE_NUMBER' | translate }}
        </span>
      </div>
    </div>

    <div class="form-group position-relative">
      <label for="pass">{{ 'CHOOSE_PASSWORD' | translate }}</label>
      <input [type]="!passwordVisibility ? 'password' : 'text'" class="auth-input w-100 input-bordered"
             id="pass" placeholder="{{ 'ENTER_YOUR_PASSWORD' | translate }}" formControlName="password">
      <mat-icon matSuffix class="position-absolute password-visibility"
                (click)="passwordVisibility = !passwordVisibility">
        {{ !passwordVisibility ? 'visibility_off' : 'visibility' }}
      </mat-icon>
      <span class="text-error" *ngIf="password?.invalid && password?.touched && password?.hasError('passwordError')">
        {{ password?.errors?.['passwordError'] | translate }}
      </span>
    </div>

    <div class="form-group position-relative">
      <label for="pass2">{{ 'CONFIRM_PASSWORD' | translate }}</label>
      <input [type]="!confirmPasswordVisibility ? 'password' : 'text'" class="auth-input w-100 input-bordered" id="pass2"
             placeholder="{{ 'ENTER_YOUR_PASSWORD' | translate }}" formControlName="confirmPassword">
      <mat-icon matSuffix class="position-absolute password-visibility"
                (click)="confirmPasswordVisibility = !confirmPasswordVisibility">
        {{ !confirmPasswordVisibility ? 'visibility_off' : 'visibility' }}
      </mat-icon>
      <div class="text-error" *ngIf="signupForm?.hasError('controlMismatch')">
        {{ 'PASSWORDS_DONT_MATCH' | translate }}
      </div>
    </div>

    <div class="mt-3">
      <mat-checkbox formControlName="conditions">
        {{ 'I_AGREE_THE' | translate }}
        <a [attr.href]="clientUrl + (accountType === userRole.tutor ? '/tutor-terms' : '/student-terms')" target="_blank">
          {{ 'TERMS_CONDITIONS' | translate | lowercase }}.
        </a>
      </mat-checkbox>
    </div>

    <div class="view-instructions sm-alert d-flex align-items-center p-3 my-4" *ngIf="error">
      <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"/>
      </svg>
      <h4 class="mb-0 mx-3 flex-grow-1" *ngIf="error === signupError">
        {{ 'ACCOUNT_ALREADY_REGISTERED' | translate }}
        <a routerLink="/signin" class="fw-bold text-decoration-underline">{{ 'LOGIN' | translate }}</a>
        {{ 'OR' | translate | lowercase }}
        <a routerLink="/forget-password" class="fw-bold text-decoration-underline">{{ 'RESET_YOUR_PASSWORD' | translate }}</a>
      </h4>
      <h4 class="mb-0 mx-3 flex-grow-1" *ngIf="error !== signupError">{{ error | translate }}</h4>
    </div>

    <div class="form-group mt-4 mb-2">
      <metutors-submit-button [form]="signupForm" [isSubmitting]="isLoading" [extraClasses]="isModal ? 'w-100 rounded-btn text-capitalize' : 'w-100 rounded-btn'">
        {{ submitLabel | translate }}
      </metutors-submit-button>
    </div>

    <ng-container *ngIf="accountType === userRole.student">
      <div class="row mt-3">
        <div class="col-12">
          <div class="or fw-bold text-center text-uppercase">{{ 'OR' | translate }}</div>
        </div>
      </div>

      <div class="row mt-3 social">
        <div class="col-xl-6 mb-1">
          <button (click)="openRolesDialog.emit('google')" mat-button type="button" class="w-100 google rounded-btn"
                  [disabled]="authLoading">
            <img src="assets/svg/google.svg" alt="" class="me-2">
            {{ (isModal ? 'GOOGLE' : 'SIGNUP_GOOGLE') | translate }}
          </button>
        </div>
        <div class="col-xl-6 mb-1">
          <button (click)="openRolesDialog.emit('facebook')" mat-button type="button" class="w-100 facebook rounded-btn"
                  [disabled]="authLoading">
            <img src="assets/svg/facebook-circle.svg" class="me-2" alt="">
            {{ (isModal ? 'FACEBOOK' : 'SIGNUP_FACEBOOK') | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <div class="form-group mt-4">
      <p>
        {{ 'ALREADY_HAVE_ACCOUNT' | translate }}
        <button mat-button (click)="signinClicked.emit(returnUrl)" class="cursor-pointer ms-2" *ngIf="isModal">{{ 'SIGNIN_NOW' | translate }}</button>
        <a [attr.href]="clientUrl + '/signin?returnUrl=' + returnUrl" target="_blank" class="ms-2" *ngIf="!isModal">{{ 'SIGNIN_NOW' | translate }}</a>
      </p>
      <p [innerHTML]="'OUR_PRIVACY_INCLUDE_INFO' | translate" class="privacy"></p>
    </div>
  </div>
</form>
